// extracted by mini-css-extract-plugin
export default {"content":"style_content__mOjMV","checkbox":"style_checkbox__Gutwg"};